import type { CreateShopTemplateProps } from "@/components/Templates/CreateShop/CreateShop.template.types";
export function renderReviewValue(row: CreateShopTemplateProps["reviewGroups"][number]["rows"][number], t: (key: string, options?: Record<string, unknown>) => string) {
  if (row.value) return row.value;
  if (row.settingsValueKeys?.length) return row.settingsValueKeys.map((key) => t(`settings:${key}`)).join("، ");
  if (row.settingsValueKey) return t(`settings:${row.settingsValueKey}`);
  return row.valueKey ? t(row.valueKey) : "";
}
